import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { getErrorFormat } from 'core/utils/errors';
import { FilterModel } from 'utils/globalModels';
import { buildUrlFilters } from 'utils/url';
import { payloadToAssetSensorListResponse } from '../mappers/payloadToSensorsAsset';
import { SensorEntityModel, SensorListResponseModel } from '../models/sensorEntityModels';
import { SensorListResponsePayload } from '../models/sensorPayloadModels';

const sortOrder = (a: SensorEntityModel, b: SensorEntityModel) => {
  if (a.name > b.name) return 1;
  if (a.name < b.name) return -1;
  return 0;
};

const getUrl = ({
  host,
  assetId,
  page,
  size,
  search,
  filters,
  showAll,
}: {
  host: string;
  assetId: string;
  page: number;
  size: number;
  search?: string;
  filters?: FilterModel;
  showAll: boolean;
}) => {
  const params = new URLSearchParams();
  showAll && params.append('show', 'all');
  page && params.append('page[number]', `${page}`);
  size && params.append('page[size]', `${size}`);
  !!search && params.append('search', search);
  !!filters?.conditions.length && params.append('filter', buildUrlFilters(filters));

  return `${host}/assets/${assetId}/sensors?${params}`;
};

export const GetSensorsListByAssetId = async ({
  host,
  token,
  assetId,
  page,
  size,
  search,
  filters,
  showAll,
}: {
  host: string;
  token: string;
  assetId: string;
  page: number;
  size: number;
  showAll: boolean;
  search?: string;
  filters?: FilterModel;
}): Promise<SensorListResponseModel> => {
  try {
    const url = getUrl({
      host,
      assetId,
      page,
      size,
      search,
      filters,
      showAll,
    });

    const options: AxiosRequestConfig = {
      url,
      method: 'GET',
      timeout: 30000,
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json;charset=UTF-8',
        Authorization: token,
        'Accept-version': '1',
      },
    };

    const { data } = (await axios(options)) as AxiosResponse<SensorListResponsePayload>;
    const devicesData = payloadToAssetSensorListResponse(data);
    return { ...devicesData, data: devicesData.data.sort(sortOrder) };
  } catch (error) {
    throw getErrorFormat(error);
  }
};
